export enum WorkflowPhase {
  planning = 1,
  authoring = 2,
  raStudio = 3,
  published = 4
}
